import {
    useProductsTableControllerOrchestration,
    type ProductsTableControllerValue,
    type UseProductsTableControllerArgs,
} from '@/components/products-table/use-products-table-controller-orchestration';

export type { UseProductsTableControllerArgs, ProductsTableControllerValue };

export const useProductsTableController = (args: UseProductsTableControllerArgs): ProductsTableControllerValue =>
    useProductsTableControllerOrchestration(args);
